import type { FirestoreEntity } from './entities';

export type User = UserEntity;

export interface UserEntity {
  authUserUid: string;
  firstName: string;
  lastName: string;
  email: string;
  orgaId: string;
}

export type FirestoreUser = FirestoreEntity<User>;

export const createUserDisplayName = (firstName: string, lastName: string): string =>
  firstName + ' ' + lastName;

const firstLetterUppercase = (value: string): string =>
  value && value[0] ? value[0].toUpperCase() : '';

export const createUserInitials = (firstName: string, lastName: string): string =>
  firstLetterUppercase(firstName) + firstLetterUppercase(lastName);
